'use strict';

var generatedCraftcms = require('@liquorice/generated-craftcms');

const FORMIE_CAPTCHA_FRAGMENT = generatedCraftcms.gql(`
  fragment formieCaptcha on FormieCaptchaType {
    __typename
    handle
    name
    value
  }
`);

exports.FORMIE_CAPTCHA_FRAGMENT = FORMIE_CAPTCHA_FRAGMENT;
